<!-- Toolbar -->
@if (showToolbar()) {
  <kl-grid-toolbar
    #gridToolbar
    [showButton]="showButton()"
    [bulkDeleteEnabled]="bulkDeleteEnabled()"
    [doRefresh]="doRefresh()"
    [doAdd]="effectiveDoAdd()"
    [doDelete]="effectiveDoDelete()"
    [doEdit]="effectiveDoEdit()"
    [doView]="effectiveDoView()"
    [filterable]="filterable()"
    [customFilter]="customFilter()"
    [doExport]="doExport()"
    [disabledButton]="disabledButton()"
    [recordFetchLoading]="recordFetchLoading()"
    [initStatesWithoutChild]="permittedInitStatesWithoutChild()"
    [initStatesWithChild]="initStatesWithChild()"
    [addInitStatesMenuModel]="addInitStatesMenuModel()"
    [editViewMenuModel]="editViewMenuModel()"
    [filterMenuModel]="filterMenuModel()"
    [exportMenuModel]="exportMenuModel()"
    [processesMenuModel]="processesMenuModel()"
    [otherMenuModel]="otherMenuModel()"
    [customToolbar]="mergedCustomToolbar()"
    [customToolbarVisible]="customToolbarVisible()"
    [showProcessesMenu]="processesActions().length > 0 && hasProcessesMenu()"
    [hasOtherMenu]="hasOtherMenu()"
    [fullscreenEnabled]="fullscreen()"
    [fullscreenActive]="fullscreenActive()"
    [menuAppendTo]="overlayAppendTo()"
    (refreshClick)="refresh()"
    (openNewClick)="openNew($event)"
    (deleteClick)="explorerDelete()"
    (editClick)="explorerEdit()"
    (viewClick)="explorerView()"
    (toggleFilterClick)="toggleFilterContainer()"
    (exportClick)="exportAs($event)"
    (customToolbarActionClick)="onCustomToolbarAction($event)"
    (toggleFullscreenClick)="toggleFullscreen()"
    (confirmBulkDeleteClick)="confirmBulkDelete()"
    (cancelBulkDeleteClick)="cancelBulkDelete()" />
}

<!-- Alert -->
<kl-alert
  [show]="alertShow()"
  [type]="alertType()"
  [message]="alertMessage()"
  [showClose]="true"
  [autoClose]="autoClose()"
  (onClose)="onAlertClose()" />

<!-- Filter bar -->
@if (showFilterContainer()) {
  <div class="filter-bar">
    <input
      type="text"
      class="filter-input"
      [placeholder]="'search_value' | translate"
      [ngModel]="textToFilter()"
      (ngModelChange)="textToFilter.set($event)"
      (keydown.enter)="submit()" />

    @if (filterSelectItems().length) {
      <p-select
        class="filter-select"
        [ngModel]="filterType()"
        (ngModelChange)="filterType.set($event)"
        [options]="filterSelectItems()"
        optionLabel="description"
        appendTo="body">
        <ng-template #selectedItem let-option>{{ option.description | translate }}</ng-template>
        <ng-template #item let-option>{{ option.description | translate }}</ng-template>
      </p-select>
    }

    <p-select
      class="filter-select filter-select--expr"
      [ngModel]="filterExpression()"
      (ngModelChange)="filterExpression.set($event)"
      [options]="filterExpressionOptions"
      optionLabel="label"
      optionValue="value"
      appendTo="body">
      <ng-template #selectedItem let-option>{{ option.label | translate }}</ng-template>
      <ng-template #item let-option>{{ option.label | translate }}</ng-template>
    </p-select>

    <input
      type="text"
      class="filter-input filter-input--count"
      inputmode="numeric"
      maxlength="3"
      [value]="pageSize()"
      (keydown)="preventNonNumeric($event)"
      (keydown.enter)="commitPageSize($event); submit()"
      (focusout)="commitPageSize($event)" />

    <div class="filter-btn-group">
      <button class="filter-btn" [disabled]="fastFilterSaving()" (click)="submit()">
        <i class="ph ph-list-bullets"></i>
        {{ 'list' | translate }}
      </button>
      @if (fastFilterQueryActive()) {
        <button
          type="button"
          class="filter-btn filter-btn--dropdown"
          [disabled]="fastFilterSaving()"
          (click)="fastFilterMenu.toggle($event)">
          <i class="ph ph-caret-down"></i>
        </button>
        <p-menu #fastFilterMenu [model]="fastFilterMenuModel()" [popup]="true" appendTo="body" />
      }
    </div>
  </div>
}

<!-- PrimeNG Table -->
<div class="grid-body">
  @if (showInitialLoader()) {
    <div class="grid-body__loading">
      <div class="grid-loading-panel">
        <kl-loader [label]="loadingText() || 'loading'" />
      </div>
    </div>
  }

  @if (columnWidthEditMode()) {
    <div class="kl-grid-column-width-edit-banner" role="status">
      <div class="kl-grid-column-width-edit-banner__text">
        <i class="ph ph-columns kl-grid-column-width-edit-banner__icon" aria-hidden="true"></i>
        <span>{{ 'column_width_edit_mode_active' | translate }}</span>
        <span class="kl-grid-column-width-edit-banner__hint">{{ 'column_width_edit_mode_hint' | translate }}</span>
      </div>
      <button
        type="button"
        class="kl-form-btn kl-form-btn--secondary kl-form-btn--sm"
        (click)="setColumnWidthEditMode(false)">
        {{ 'column_width_edit_mode_done' | translate }}
      </button>
    </div>
  }

  <div
    class="grid-host"
    [class.grid-host--blocked]="showLoadingOverlay()"
    [class.grid-host--column-width-edit]="columnWidthEditMode()">
    @if (showLoadingOverlay()) {
      <div class="grid-body__overlay">
        <kl-loader [label]="loadingText() || 'loading'" />
      </div>
    }
    <p-table
      #dt
      [attr.aria-busy]="loading() || null"
      [columns]="columnReorderEnabled() ? tableColumnMeta() : []"
      [value]="filteredData()"
      [scrollable]="true"
      scrollHeight="65vh"
      [virtualScroll]="effectiveVirtualScroll()"
      [virtualScrollItemSize]="virtualScrollItemSize()"
      selectionMode="single"
      [selection]="selectedRow()"
      (selectionChange)="selectedRow.set($event)"
      (onRowSelect)="onRowSelect($event)"
      [dataKey]="gridDataKey()"
      [rowExpandMode]="rowExpandMode()"
      [expandedRowKeys]="expandedRowKeys()"
      (onRowExpand)="onRowExpand($event)"
      (onRowCollapse)="onRowCollapse($event)"
      [rowHover]="false"
      class="p-datatable-sm kl-grid-table"
      [class.kl-grid-table--fixed]="effectiveVirtualScroll()"
      [reorderableColumns]="columnReorderEnabled()"
      [resizableColumns]="columnResizeEnabled()"
      columnResizeMode="expand"
      (onColReorder)="onColReorder($event)"
      (onColResize)="onColResize($event)">
      <ng-template #gridHeaderCellBody let-col="col">
        <div class="kl-grid-header-content" (mousedown)="$event.stopPropagation()">
          <span>{{ col.header ? (col.header | translate) : '' }}</span>
          @if (col.binding && (columnFilters() || sortable())) {
            <kl-column-filter
              [column]="col"
              [data]="data()"
              [filterState]="getColumnFilterState(col)"
              [showSort]="sortable()"
              [showValueFilter]="columnFilters()"
              (sortAsc)="onColumnSortAsc($event)"
              (sortDesc)="onColumnSortDesc($event)"
              (filterApply)="onColumnFilterApply($event)"
              (filterClear)="onColumnFilterClear($event)" />
          }
        </div>
      </ng-template>

      <ng-template #header>
        <tr>
          <!-- Top-left: column settings (body rows use same column for row expand when enabled) -->
          <th
            pFrozenColumn
            class="kl-grid-rowheader-col kl-grid-rowheader-col--header"
            [class.kl-grid-rowheader-col--with-expand]="!!rowExpansionTemplate()"
            scope="col"
            (click)="openSidebar()">
            <i class="ph ph-gear grid-settings-icon"></i>
          </th>
          @for (col of visibleColumns(); track col.binding) {
            @if (col.multi_select) {
              <th class="kl-grid-header-cell kl-grid-header-cell--checkbox" [style.width]="getColWidth(col)">
                <p-checkbox
                  [ngModel]="allChecked()"
                  (ngModelChange)="allChecked.set($event); toggleAllCheckboxes()"
                  [binary]="true" />
              </th>
            } @else if (col.binding && columnReorderEnabled() && columnResizeEnabled()) {
              <th pReorderableColumn pResizableColumn [style.width]="getColWidth(col)" class="kl-grid-header-cell">
                <div class="kl-grid-header-cell-wrap">
                  <span
                    class="kl-grid-col-drag-handle ph ph-dots-six-vertical"
                    [attr.aria-label]="'column_drag_to_reorder' | translate"
                    [pTooltip]="'column_drag_to_reorder' | translate"
                    tooltipPosition="bottom"></span>
                  <ng-container *ngTemplateOutlet="gridHeaderCellBody; context: { col: col }"></ng-container>
                </div>
              </th>
            } @else if (col.binding && columnReorderEnabled()) {
              <th pReorderableColumn [style.width]="getColWidth(col)" class="kl-grid-header-cell">
                <div class="kl-grid-header-cell-wrap">
                  <span
                    class="kl-grid-col-drag-handle ph ph-dots-six-vertical"
                    [attr.aria-label]="'column_drag_to_reorder' | translate"
                    [pTooltip]="'column_drag_to_reorder' | translate"
                    tooltipPosition="bottom"></span>
                  <ng-container *ngTemplateOutlet="gridHeaderCellBody; context: { col: col }"></ng-container>
                </div>
              </th>
            } @else if (col.binding && columnResizeEnabled()) {
              <th pResizableColumn [style.width]="getColWidth(col)" class="kl-grid-header-cell">
                <ng-container *ngTemplateOutlet="gridHeaderCellBody; context: { col: col }"></ng-container>
              </th>
            } @else if (col.binding) {
              <th [style.width]="getColWidth(col)" class="kl-grid-header-cell">
                <ng-container *ngTemplateOutlet="gridHeaderCellBody; context: { col: col }"></ng-container>
              </th>
            } @else {
              <th [style.width]="getColWidth(col)" class="kl-grid-header-cell">
                <div class="kl-grid-header-content">
                  <span>{{ col.header ? (col.header | translate) : '' }}</span>
                </div>
              </th>
            }
          }
        </tr>
      </ng-template>

      <ng-template #body let-row let-ri="rowIndex" let-expanded="expanded">
        <tr
          [pSelectableRow]="row"
          [pSelectableRowIndex]="ri"
          (dblclick)="onRowDblClick(row)"
          (keydown)="onRowKeydown($event, row)"
          (contextmenu)="onRowContextMenu($event, row)"
          [class.kl-grid-row--selected]="selectedRow() === row"
          [class.kl-grid-row--alt]="ri % 2 === 1">
          <td
            pFrozenColumn
            class="kl-grid-rowheader-col"
            [class.kl-grid-rowheader-col--with-expand]="!!rowExpansionTemplate()">
            @if (rowExpansionTemplate()) {
              <button
                type="button"
                class="kl-grid-expand-toggle"
                [attr.aria-expanded]="!!expanded"
                [attr.aria-label]="'detail' | translate"
                (click)="$event.stopPropagation()"
                pRowToggler
                [pRowToggler]="row">
                <i
                  class="grid-settings-icon ph"
                  [class.ph-minus]="expanded"
                  [class.ph-plus]="!expanded"
                  aria-hidden="true"></i>
              </button>
            }
          </td>
          @for (col of visibleColumns(); track col.binding) {
            @if (col.multi_select && col.binding) {
              <td class="kl-grid-cell--checkbox" [style.width]="getColWidth(col)">
                <p-checkbox
                  [(ngModel)]="row[col.binding]"
                  (onChange)="onCheckboxChange($event, row)"
                  [binary]="true"
                  [disabled]="rowEntityId(row) == null" />
              </td>
            } @else if (col.binding && columnResizeEnabled()) {
              @let cellValue = row | klGridCellValue: col;
              <td
                pResizableColumn
                [style.width]="getColWidth(col)"
                [style.text-align]="col.align || ''"
                [class]="col.cssClass || ''">
                @if (col.icon && col.binding) {
                  <i [class]="row[col.binding!] || ''"></i>
                } @else if (col.icon_key && col.binding) {
                  @if (row[col.binding!] === 'YES') {
                    <i class="ph-fill ph-key" aria-hidden="true"></i>
                  }
                } @else if (col.icon_info && col.binding) {
                  @if (row[col.binding!] === 'YES') {
                    <i class="ph ph-info" aria-hidden="true"></i>
                  }
                } @else if (col.button && col.rowActionName) {
                  <button type="button" class="kl-grid-row-btn" (click)="onRowButtonClick(col, row, $event)">
                    <i [class]="col.cssClass || 'ph ph-dots-three'"></i>
                  </button>
                } @else if (col.badge && col.binding) {
                  @if (cellValue) {
                    @if (col.badgeTones) {
                      @let tone = statusBadgeTone(row, col);
                      <span [class]="'kl-status-badge' + (tone ? ' kl-status-badge--' + tone : '')">
                        {{ cellValue }}
                      </span>
                    } @else {
                      <p-tag [value]="cellValue" [severity]="row | klGridCellSeverity: col" />
                    }
                  }
                } @else {
                  {{ cellValue }}
                }
              </td>
            } @else {
              @let cellValue = row | klGridCellValue: col;
              <td
                [style.width]="getColWidth(col)"
                [style.text-align]="col.align || ''"
                [class]="col.cssClass || ''">
                @if (col.icon && col.binding) {
                  <i [class]="row[col.binding!] || ''"></i>
                } @else if (col.icon_key && col.binding) {
                  @if (row[col.binding!] === 'YES') {
                    <i class="ph-fill ph-key" aria-hidden="true"></i>
                  }
                } @else if (col.icon_info && col.binding) {
                  @if (row[col.binding!] === 'YES') {
                    <i class="ph ph-info" aria-hidden="true"></i>
                  }
                } @else if (col.button && col.rowActionName) {
                  <button type="button" class="kl-grid-row-btn" (click)="onRowButtonClick(col, row, $event)">
                    <i [class]="col.cssClass || 'ph ph-dots-three'"></i>
                  </button>
                } @else if (col.badge && col.binding) {
                  @if (cellValue) {
                    @if (col.badgeTones) {
                      @let tone = statusBadgeTone(row, col);
                      <span [class]="'kl-status-badge' + (tone ? ' kl-status-badge--' + tone : '')">
                        {{ cellValue }}
                      </span>
                    } @else {
                      <p-tag [value]="cellValue" [severity]="row | klGridCellSeverity: col" />
                    }
                  }
                } @else {
                  {{ cellValue }}
                }
              </td>
            }
          }
        </tr>
      </ng-template>

      @if (rowExpansionTemplate(); as rowExpTpl) {
        <ng-template pTemplate="expandedrow" let-row>
          <tr class="kl-grid-row-expansion">
            <td [attr.colspan]="tableLeadColSpan()" class="kl-grid-row-expansion__cell">
              <div class="kl-grid-row-expansion__inner" (click)="$event.stopPropagation()">
                <ng-container *ngTemplateOutlet="rowExpTpl; context: { $implicit: row, item: row }" />
              </div>
            </td>
          </tr>
        </ng-template>
      }

      <ng-template #emptymessage>
        <tr>
          <td [colSpan]="tableLeadColSpan()" class="text-center kl-grid-empty">{{ 'no_data' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>

    @if (showTablePaginator()) {
      <p-paginator
        class="kl-grid-paginator"
        [first]="pageFirst()"
        [rows]="pageSize()"
        [totalRecords]="totalRecords()"
        [showPageLinks]="false"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="pageReportTemplate()"
        [showFirstLastIcon]="true"
        [templateLeft]="paginatorLeft"
        (onPageChange)="onTablePage($event)">
        <ng-template pTemplate="firstpagelinkicon">
          <i class="ph-bold ph-caret-double-left" aria-hidden="true"></i>
        </ng-template>
        <ng-template pTemplate="previouspagelinkicon">
          <i class="ph-bold ph-caret-left" aria-hidden="true"></i>
        </ng-template>
        <ng-template pTemplate="nextpagelinkicon">
          <i class="ph-bold ph-caret-right" aria-hidden="true"></i>
        </ng-template>
        <ng-template pTemplate="lastpagelinkicon">
          <i class="ph-bold ph-caret-double-right" aria-hidden="true"></i>
        </ng-template>
      </p-paginator>

      <ng-template #paginatorLeft>
        <span class="kl-grid-paginator-range">
          @if (isColumnFiltered()) {
            {{ 'grid_paginator_report_filtered' | translate: gridPaginatorReportParams() }}
          } @else {
            {{ 'grid_paginator_report' | translate: gridPaginatorReportParams() }}
          }
        </span>
      </ng-template>
    }
  </div>
</div>

<!-- Row context menu -->
<p-contextMenu #contextMenu [model]="contextMenuModel()" [appendTo]="overlayAppendTo()"></p-contextMenu>

<kl-grid-column-settings-drawer
  #columnSettingsDrawer
  [visible]="sidebarVisible()"
  (visibleChange)="sidebarVisible.set($event)"
  [initialTab]="drawerInitialTab()"
  [appendTo]="overlayAppendTo()"
  [columnDefinitions]="effectiveColumns()"
  [endpointName]="endpointName()"
  [designParentModule]="designParentModule()"
  [designModule]="designModule()"
  [designKey]="designKey()"
  [captureColumnWidths]="captureColumnWidths"
  [columnWidthEditMode]="columnWidthEditMode()"
  (columnWidthEditModeChange)="setColumnWidthEditMode($event)"
  (resetToDefault)="onColumnDrawerResetToDefault()"
  (columnsChanged)="onColumnsChanged($event)" />
